import { Component, Input, OnInit } from '@angular/core';
import { FileUploadDto } from '../../service/dto';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HttpFileService } from '../../service/http-file.service';

@Component({
	selector: 'app-preview-modal',
	standalone: false,
	templateUrl: './preview-modal.component.html',
	styleUrl: './preview-modal.component.scss'
})
export class PreviewModalComponent implements OnInit {
	@Input() file?: string | FileUploadDto;
	@Input() src?: SafeUrl;
	loading = false;

	constructor(private modal: NzModalRef, private sanitizer: DomSanitizer, private httpService: HttpFileService) { }

	ngOnInit(): void {
		if (!this.src && this.file) {
			this.loading = true;
			this.httpService.preview(typeof this.file === 'string' ? this.file : (this.file as FileUploadDto).uuid).subscribe(result => {
				const data = result.body!;
				const pdfBlob = new Blob([data], { type: 'application/pdf' });
				const url = URL.createObjectURL(pdfBlob);
				this.src = this.sanitizer.bypassSecurityTrustResourceUrl(url);
			});
		}
	}
}
